module.exports = __webpack_public_path__ + "img/twitter.6e44219.svg";